import { NgIf } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { DialogModule } from 'primeng/dialog'

@Component({
	selector: 'app-ui-dialog',
	standalone: true,
	imports: [DialogModule, NgIf, TranslateModule],
	templateUrl: './ui-dialog.component.html',
	styleUrl: './ui-dialog.component.scss'
})
export class UiDialogComponent {
	@Input() visible: boolean = false
	@Input() title: string = 'ERROR'
	@Input() primaryLabel: string = 'ACCEPT'
	@Input() secondaryLabel?: string
	@Input() dialogClass?: string
	@Input() hideHeader: boolean = false
	@Input() hideFooter: boolean = false
	@Input() showCloseButton: boolean = true
	@Input() dismissableMask: boolean = true
	@Input() closeOnEscape: boolean = true
	@Input() width: string = 'min(560px, calc(100vw - 2rem))'
	@Input() breakpoints: Record<string, string> = {
		'960px': '75vw',
		'640px': 'calc(100vw - 1.5rem)'
	}

	@Output() primaryAction = new EventEmitter<void>()
	@Output() secondaryAction = new EventEmitter<void>()
	@Output() closeAction = new EventEmitter<void>()

	onPrimaryAction() {
		this.primaryAction.emit()
	}

	onSecondaryAction() {
		this.secondaryAction.emit()
	}

	onClose() {
		this.closeAction.emit()
	}

	get styleClassName(): string {
		return this.dialogClass ? `pgc-ui-dialog ${this.dialogClass}` : 'pgc-ui-dialog'
	}
}
